__turbopack_context__.v({
  "image": "ErrorLayout-module-scss-module__StwEPq__image",
  "wrapper": "ErrorLayout-module-scss-module__StwEPq__wrapper",
});
